import React, { useState } from "react";
import { Modal, InputNumber } from "antd";

const EditCartModal = ({
  isEditModalVisible,
  handleClose,
  handleConfirm,
  currentEditItem,
}) => {
  const { item: { quantity, designName }} = currentEditItem
  const [changedItem, setChangedItem ] = useState({ quantity })
  return (
    <Modal
      visible={isEditModalVisible}
      destroyOnClose={true}
      title={`Edit Cart for Design: ${designName || ''}`}
      okText="Confirm"
      onOk={() => handleConfirm(currentEditItem, changedItem)}
      onCancel={() => {
        handleClose();
      }}
    >
      <span style={{ marginRight: "4px"}}>Quantity</span>
      <InputNumber min={1} defaultValue={quantity || 0} onChange={(value) => setChangedItem({ quantity: value })} />
    </Modal>
  );
};

export default EditCartModal;
